import ToolTip from "@/components/shared/ToolTip";
import { isValidSin } from "@/lib/util";
import { setSin } from "@/slices/applicantSlice";
import { RootState } from "@/store/dtm";
import style from "@/styles/pages/Sin/Sin.module.css";
import clsx from "clsx";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

export default function JointSin() {
  const [sinShown, setSinShown] = useState(false);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const applicant = useSelector(
    (state: RootState) => state.applicant.applicant
  );

  const application = useSelector(
    (state: RootState) => state.application.application
  );

  const toggleSinVisiblity = () => {
    setSinShown(sinShown ? false : true);
  };

  useEffect(() => {
    document.title = "What's your social insurance number?";

    //setClickInsightEvents(application);
  }, []);
  
  const methods = useForm({
    defaultValues: {
      sin: "",
    },
  });

  const onError = (errors: object) => {
    //setClickInsightFormErrors(errors);
  }
  
  const onSubmit = (data: any) => {
    dispatch(setSin(data.sin));

    navigate("/joint/legal-terms");
  };

  return (
    <main aria-labelledby="main-content">
      <div className="flex flex-col max-xs:px-3 sm:ml-80 max-md:items-center max-md:mt-20">
        <div className={style.sinHeading}>
          <h1>What’s your Social Insurance Number?</h1>
          <p className="sub-heading">
            This account earns interest and having your SIN means we can send
            you the proper tax slips. It also helps us match your credit details
            with the credit bureau to verify your identity right away. If you’d
            rather not provide your SIN online, you can open an account in
            person at any Meridian branch.
          </p>
          <div className="flex flex-row mt-5">
            <form onSubmit={methods.handleSubmit(onSubmit,onError)}>
              <div className="col-span-1">
                <div
                  className={clsx(
                    "flex mt-5",
                    style.Sin
                  )}
                >
                  <span className="mr-1"> Social Insurance Number (SIN)</span>
                  <span className="ml-2">
                    <ToolTip
                      title="Where can I find my SIN?"
                      content="If you can’t remember your SIN, you can find it on your income tax return, tax slips, record of employment and RRSP contribution form."
                      classNames={style.sinToolTip}
                    />
                  </span>
                </div>
                <div className="flex relative">
                  <span className={clsx(sinShown ? "hidden" : " ")}>
                    <img
                      onClick={toggleSinVisiblity}
                      src="assets/eye-icon.svg"
                      className={clsx(
                        "w-4 h-4 absolute top-6 max-xxs:ml-[210px] max-sm:ml-[300px] xs:max-md:ml-[370px] md:ml-[430px]"
                      )}
                      alt="error"
                      height={5}
                      width={5}
                    />
                  </span>
                  <span className={clsx(sinShown ? " " : "hidden")}>
                    <img
                      onClick={toggleSinVisiblity}
                      src="assets/eye-slash-icon.svg"
                      className={clsx(
                        "w-4 h-4 absolute top-6 max-xxs:ml-[210px] max-sm:ml-[300px] xs:max-md:ml-[370px] md:ml-[430px]"
                      )}
                      alt="error"
                      height={5}
                      width={5}
                    />
                  </span>
                  <input
                    className={clsx(
                      methods.formState?.errors?.sin ? "error" : "",
                      "mt-2"
                    )}
                    type={sinShown ? "text" : "password"}
                    {...methods.register("sin", {
                      validate: {
                        sinValidator: (v) => isValidSin(v) == true,
                      },
                      required: "Enter a valid SIN",
                    })}
                  />
                </div>
                {methods.formState?.errors?.sin?.message && (
                  <span className="flex items-center font-medium tracking-wide text-red-500 text-xs mt-1 ml-1">
                    {methods.formState.errors.sin.message}
                  </span>
                )}
                {methods.formState?.errors?.sin?.type == "sinValidator" && (
                  <span className="flex items-center font-medium tracking-wide text-red-500 text-xs mt-1 ml-1">
                    Enter a valid SIN
                  </span>
                )}
              </div>
              <div className="flex max-sm:hidden">
                <div className="mb-5">
                  <button type="submit" className="primary mt-5 w-169 sm:w-28 h-11 px-6">
                    Continue
                  </button>
                </div>
              </div>
              <div className="sm:hidden">
                <div className="mb-5">
                  <button type="submit" className="primary mt-5 w-full h-11 px-6">
                    Continue
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </main>
  );
}
